import { Routes } from '@angular/router';

export const userAuthorizationsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/leasing-company/user-authorizations/overview/overview.component').then(component => component.OverviewComponent),
  },
  {
    path: ':id',
    loadComponent: () => import('@app/leasing-company/user-authorizations/details/details.component').then(component => component.DetailsComponent),
  },
  {
    path: ':id/edit',
    loadComponent: () => import('@app/leasing-company/user-authorizations/edit/edit.component').then(component => component.EditComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
